import type { Bounds, LatLng } from "@oshimap/domain";

/** 캐시 키를 한 곳에서 만든다. Web 과 Native 가 같은 키를 쓴다. */
const round = (n: number) => Math.round(n * 1000) / 1000;

export const queryKeys = {
  places: (q: Record<string, unknown> = {}) => ["places", q] as const,
  place: (id: string) => ["place", id] as const,
  tags: () => ["tags"] as const,
  events: (q: Record<string, unknown> = {}) => ["events", q] as const,
  event: (id: string) => ["event", id] as const,
  mapBounds: (b: Bounds, q: Record<string, unknown> = {}) =>
    ["map", "bounds", round(b.north), round(b.south), round(b.east), round(b.west), q] as const,
  mapNearby: (p: LatLng, radiusKm: number, q: Record<string, unknown> = {}) =>
    ["map", "nearby", round(p.latitude), round(p.longitude), radiusKm, q] as const,
  favorites: () => ["favorites"] as const,
  passport: () => ["passport"] as const,
  passportStamps: () => ["passport", "stamps"] as const,
  passportTimeline: () => ["passport", "timeline"] as const,
  search: (q: string, filters: Record<string, unknown> = {}) => ["search", q, filters] as const,
  placeLive: (placeId: string) => ["place", placeId, "live"] as const,
  notifications: () => ["notifications"] as const,
  reports: () => ["reports"] as const,
  interests: () => ["interests"] as const,
  recommendations: () => ["recommendations"] as const,
  shareCard: () => ["passport", "share-card"] as const,
  me: () => ["me"] as const,
} as const;
